export enum CostItemsView {
    "All" = "All",
    "Approved" = "Approved",
    "Rejected" = "Rejected",
    "Pending" = "Pending"
}